<template>
	<router-link
		tag="a"
		target="_blank"
		:to="'/orders/search?customer=' + id"
		class="btn btn-outline-primary"
	>
		Rendelés történet
	</router-link>
</template>
<script type="text/javascript">
export default {
	props: ['id']
}
</script>


// WEBPACK FOOTER //
// src/components/orderHistory.vue